/*
 * Amon Atelier — persist the collection "View by" (per-row) setting across pages.
 *
 * Madrid renders the grid with the section's default_per_row, so the chosen view
 * resets when you switch collections. This stores the user's choice (small/large)
 * in localStorage and re-applies it on every collection page: it sets
 * data-productis-in-row on the grid (CSS reacts to it) and the .active class on
 * the per-row buttons. Pairs with Madrid's products-per-row.js, which handles the
 * live toggle; this only adds persistence.
 */
(function () {
  // Key the saved choice PER TEMPLATE (e.g. template-collection vs
  // template-collection-content-collection), so each template's editor "Default per row"
  // stays the default and a shopper's toggle only persists within that template — no global
  // value bleeding across templates / overriding their defaults.
  function key() {
    var t = (document.body.className.match(/template-[\w-]+/g) || [])
      .sort(function (a, b) { return b.length - a.length; })[0] || 'template';
    return 'aa_products_per_row__' + t;
  }

  function apply(value) {
    if (value !== 'small' && value !== 'large') return;
    document.querySelectorAll('[data-productis-in-row]').forEach(function (el) {
      el.setAttribute('data-productis-in-row', value);
    });
    document.querySelectorAll('.per-row__button').forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-per-row') === value);
    });
  }

  function save(value) {
    try { localStorage.setItem(key(), value); } catch (e) {}
  }

  function read() {
    try { return localStorage.getItem(key()); } catch (e) { return null; }
  }

  function init() {
    // Restore the saved view (if any) on load.
    apply(read());

    // Save the choice whenever a per-row button is clicked.
    document.querySelectorAll('.per-row__button').forEach(function (btn) {
      if (btn.dataset.aaViewBound) return; // avoid double-binding on section reloads
      btn.dataset.aaViewBound = '1';
      btn.addEventListener('click', function () {
        save(this.getAttribute('data-per-row'));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-apply when sections re-render in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();

/* --------------------------------------------------------------------------
 * AA: PLP desktop — on product-card hover, advance the image carousel to image 2
 * (Swiper slide index 1) so the 2nd photo shows and its index line auto-highlights;
 * slide back to image 1 on mouse-leave. Arrows + index are revealed by CSS hover.
 * Delegated on document (enter/leave detected via relatedTarget) so it keeps working
 * for cards re-rendered after filtering. Swiper exposes its instance on the container
 * element (.product-card-js) as `.swiper`.
 * -------------------------------------------------------------------------- */
(function () {
  var DESKTOP = '(min-width: 990px)';

  function go(card, index) {
    if (!window.matchMedia(DESKTOP).matches) return;
    // Content collection products are static — no hover image-swap there.
    if (document.body.classList.contains('template-collection-content-collection')) return;
    var el = card.querySelector('.product-card-js');
    var sw = el && el.swiper;
    // speed 0 = jump instantly to the image, no slide animation.
    if (sw && sw.slides && sw.slides.length > 1) sw.slideTo(index, 0);
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || card.contains(e.relatedTarget)) return; // only when entering the card
    go(card, 1);
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || card.contains(e.relatedTarget)) return; // only when leaving the card
    go(card, 0);
  });
})();
